/*
 * Copyright (c) 2019. Nedaware SL
 */

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */

/**
 * Strings for the types to be usable in switchs
 *
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
export enum TypeStr {
    String = 'string',
    Text = 'text',
    Uri = 'uri',
    Integer = 'integer',
    Float = 'float',
    Financial = 'financial',
    Choice = 'choice',
    Boolean = 'boolean',
    Decimal = 'decimal',
    DateTime = 'datetime',
    Date = 'date',
    Time = 'time',
    NestedModel = 'nested-model',
    Object = 'object',
    Dictionary = 'dictionary',
    Translation = 'translation',
    Email = 'email',
    PhoneNumber = 'phone',
    Image = 'image',
    ExternalLink = 'link'
}
